exports.ALL = [
	'simple clothes',
	'plain clothes',
	'well-made clothes',
	'travelers\'s clothes',
	'rich clothes',
	'luxurious clothes',
];


// WEBPACK FOOTER //
// ./src/data/clothes.js